import { render } from "./SocialNetworkServiceParameter.vue?vue&type=template&id=e7f745a4&scoped=true"
import script from "./SocialNetworkServiceParameter.vue?vue&type=script&lang=ts"
export * from "./SocialNetworkServiceParameter.vue?vue&type=script&lang=ts"

import "./SocialNetworkServiceParameter.vue?vue&type=style&index=0&id=e7f745a4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e7f745a4"

export default script